import { render } from "./DetailSettings.vue?vue&type=template&id=6c1246a1&scoped=true"
import script from "./DetailSettings.vue?vue&type=script&lang=js"
export * from "./DetailSettings.vue?vue&type=script&lang=js"

import "./DetailSettings.vue?vue&type=style&index=0&id=6c1246a1&scoped=true&lang=less"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1246a1"]])

export default __exports__